import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { jiraCardOpenInJira, jiraConfigureVisibleCustomFields, } from './AtlassianCommands';
import { JiraCard } from './JiraCard';
import { JiraBulkChangeMenu } from './fields/JiraBulkChangeMenu';

const bulkChange = PropertyStripLayout<JiraCard>((d, s, o, w, a) => [
    w.createPopout({
        text: 'Bulk Change',
        ui: JiraBulkChangeMenu,
    })
]);

export const jiraCardPropertyLayout = LockablePropertyStripLayout<JiraCard>((d, s, o, w, a) => {

    return [
        ...(a.count > 1 ? [
            ...bulkChange(d, s, o, w, a),
            w.createDivide(),
        ] : []),
        w.createButton({
            text: 'Open In Jira',
            image: 'deqo://icons/hero/external-link',
            onAction() {
                d(jiraCardOpenInJira);
            }
        }),
        w.createButton({
            text: 'Configure Fields',
            image: 'deqo://icons/hero/cog',
            onAction() {
                d(jiraConfigureVisibleCustomFields);
            }
        }),
        w.createDivide(),
        //
        // Divider
        // w.createDivide(),
        ...lockAndMoreLayout(d, s, o, w, a),
    ];
});
